<template>
  <div>
    <carousel v-bind:imgPaths="imgPaths"/>
    <b-container>
      <b-row class="fadeable">
        <b-col class="home-content-img">
          <img id="blue-diver-img" class="home-content-img" src="../assets/img/polymachine.png" alt="">
        </b-col>
        <b-col>
          <h1 class="section-heading">
            World-class Medical Equipment
          </h1>
          <p class="section-paragraph">
            Our objective is to introduce high quality products, which will meet the needs of our customers, committed to provide the best possible customer services, excellent quality and the most advanced products. For several years, BelAsia Ltd. has earned a reputation in the medical field as a reliable distributor rendering excellent customer services to our ever-increasing circle of customers.
          </p>
        </b-col>
      </b-row>
      <b-row class="fadeable">
        <b-col>
          <h1 class="section-heading">
            Activities
          </h1>
          <p class="section-paragraph paragraph-left list">
            <ul>
              <li>Marketing and distribution of reagents, instruments, laboratory disposals for Diagnostics & Life Science medical devices and consumable products in the medical fields.</li>
              <li>Marketing and distribution of advanced wound care products from the UK.</li>
              <li>Marketing and promotion of the products from Company portfolio.</li>
              <li>Set up good relation with medical specialists.</li>
              <li>Customer training and support</li>
              <li>Technical & engineering services. </li>
              <li>Organizing campaigns, workshops and attending conferences. </li>
              <li>Setting up complete laboratories.</li>
            </ul>
          </p>
        </b-col>
        <b-col class="home-content-img">
          <img id="working-together-img" class="home-content-img" src="../assets/img/working-together.jpg" alt="">
        </b-col>
      </b-row>
      <b-row class="fadeable">
        <b-col class="home-content-img">
          <img id= "handshake-img" src="../assets/img/handshake.png" alt="">
        </b-col>
        <b-col>
          <h1 class="section-heading">
            Our Customers
          </h1>
          <p class="section-paragraph list">
            <ul>
              <li>Hospital & Medical Centers</li>
              <li>Clinical Laboratories</li>
              <li>Doctor's Practicioners Groups</li>
              <li>Industry-based clinics</li>
              <li>Laboratories</li>
              <li>Sub-dealers in remote areas</li>
            </ul>
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import carousel from '@/components/carousel.vue'

export default {
  // eslint-disable-next-line
  name: 'Home',
  components: {
    carousel
  },
  data: function(){
    return{
      imgPaths: ["colorful-test-kits.jpg", "wound-dressing-advancis.jpg", "test-vial.jpg", "zentech-baby2.jpg", "activon-tube-pouring-advancis.jpg", "test-kits.jpg", "colorful-test-kits.jpg"]
    }
  },
  created() {
    window.addEventListener('scroll', this.activateFadeables);
  },
  destroyed() {
    window.removeEventListener('scroll', this.activateFadeables);
  }
}
</script>